export default "__VITE_ASSET__C9mVrwJ4__"